import React, { useEffect, useState } from "react";
import "./Return_order.css"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleArrowLeft, faCircleChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { Link, useParams } from "react-router-dom";
import Order_details_table from "../order_details/order_details_table/Order_details_table";
import Select_reason_heading from "../../../../common/common_components/select_reason_heading/Select_reason_heading";
import Reason_cancelling_field_holder from "../../../../common/common_components/reason_cancelling_field_holder/Reason_cancelling_field_holder";
import { useDispatch, useSelector } from "react-redux";
import { getOrder } from "../../../../../features/order/orderSlice";
import { decodeId, encodeId, formatDate, formatNewDate } from "../../../../../utils/common";
import { CancelReasons, ReturnReasons } from "../../../../../features/admin/common/Slice";
import Successfull_Modal from "../../../../common/modals/common-modal/successfull_modal/Successfull_Modal";
import { AllAppsetup } from "../../../../../features/admin/footer/Slice";



function Return_order() {


  const breadcrumbs = [
    { label: "Home", link: "/", isActive: false },
    { label: "MY ORDERS", link: "/account", isActive: false },
    { label: "ORDER DETAILS", link: "/order-details", isActive: false },
    { label: "Return ORDER", link: "", isActive: true },
  ];

  const { id } = useParams();

  const dispatch = useDispatch();
  const order = useSelector((state) => state.order.order);


  console.log(decodeId(id), "kkkkkkkkkkk");

  useEffect(() => {
    const res = dispatch(getOrder(decodeId(id)));
    if (res.meta?.requestStatus === "fulfilled") {
    } else if (res.meta?.requestStatus === "rejected") {
    }
  }, [id, dispatch]);


  const data = {
    total_mrp: order?.total_mrp,
    total_tax: order?.total_tax,
    total_cess: order?.cess_tax,
    no_of_item: order?.no_of_item,
    total_selling_price: order?.total_selling_price,
    total_selling_price_gst: order?.total_selling_price_gst,
    total_mrp_gst: order?.total_mrp_gst,
    total_coupon_discount: order?.total_coupon_discount,
    total_offer_discount: order?.total_offer_discount,
    grand_total: order?.total_amount,
    total_delivery_charges: order?.delivery_charges,
    platform_fee: order?.platform_fee,
    payment_method: order?.Payment_Method?.name,
    total_savings: order?.total_mrp - order?.total_selling_price
  };


  const [cancelReason, setCancelReason] = useState();
  const [selectedItems, setSelectedItems] = useState([]);
  const [cancelReasonId, setCancelReasonId] = useState(null);
  const [cancelReasonName, setCancelReasonName] = useState(null);

  const [error, setError] = useState(false);

  const cancel_reasons = useSelector((state) => state.common.return_reasons);
  const reasonsWithOther = [
    ...(cancel_reasons || []),
    {
      value: -1,
      label: "Other",
      name: "cancel_reason_id",
    },
  ];
  useEffect(() => {
    dispatch(ReturnReasons());
  }, [dispatch]);




  return (
    <>
      <section className="Return_order">
        <div className=" return_order_holder">
          <div className="container">
            <div className="title_holder">
              <div className="heading_holder">
                <h4 >
                  <Link to={`/order-details/${id}`}>
                    <FontAwesomeIcon className=" arrow_icon me-sm-3 me-2" icon={faCircleChevronLeft} />
                  </Link>{" "}
                  Return Order
                </h4>
              </div>

              <div className="text_holder">
                <h6>Order ID #{order?.invoice_no}</h6>
                <h5>{formatNewDate(order?.createdAt, "datetime") || ""}</h5>
              </div>
            </div>


            <Order_details_table
              showCheck
              showReturn
              Order={order}
              products={order?.Product_Order_Details || []}
              selectedItems={selectedItems}
              setSelectedItems={setSelectedItems} setError={setError}
              error={error} />

            {/* <Select_reason_heading
              type={"Return"}
              cancel_reasons={cancel_reasons}
              setError={setError}
              error={error}
              cancelReasonId={cancelReasonId}
              setCancelReasonId={setCancelReasonId}
              setCancelReasonName={setCancelReasonName}
              cancelReasonName={cancelReasonName} /> */}


            <Reason_cancelling_field_holder
              cancel_reasons={reasonsWithOther}
              type={"Return"}
              cancelReason={cancelReason}
              setCancelReason={setCancelReason}
              selectedItems={selectedItems}
              cancelReasonId={cancelReasonId}
              setCancelReasonId={setCancelReasonId}

              order={order}
              setError={setError}
              error={error}
            />

          </div>
        </div>
      </section>


    </>
  );
}

export default Return_order;
